import React from "react";
import styled from "styled-components";
import Image from "@theme/assets/icon-tooltip.svg";
import Wrapper from "./textArea.styles";
import { ValidationMessage } from "../validationMessage";

const TextAreaValidationMessage = styled(ValidationMessage)`
  position: static;
`;

export default function TextArea({ ...props }) {
  const {
    title,
    errorMessage,
    toolTipText,
    OptionalLabel,
    rows=6,
    cols=10,
    value,
    ...rest
  } = props;

  return (
    <Wrapper>
      <div className="textArea">
          <div className="textArea-Label-Container">
          {title && (
            <label className="textArea-Label" htmlFor={rest.name}>
              {title}
              {!!toolTipText && (
                <i className="toolTip-Icon">
                  <img src={Image} alt="help icon" />
                  <span className="toolTip-Text">{toolTipText}</span>
                </i>
              )}

              {OptionalLabel && (
                <label className="textArea-Label-Optional">optional</label>
              )}
            </label>
          )}
        </div>
        <div className={`textArea-Input ${errorMessage ? "required" : ""}`}>
          <textarea {...rest} id={rest.name} value={value || ''} rows={rows} cols={cols} />
        </div>
        <TextAreaValidationMessage errorMessage={errorMessage} />
      </div>
    </Wrapper>
  );
}
